// generated from 831 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const xSpecificPurchasePropertyInYDaysGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("x_specific_purchase_property_in_y_days"),
  comparison_key: z.enum([
    "3", // 640 (77.02%)
    "1", // 184 (22.14%)
    "5", // 7 (0.84%)
  ]),
  display_name: z.string(),
  // undefined: 158 (19.01%), defined 673 (80.99%)
  raw_value: z
    .object({
      num_days: z.int().min(0).max(31),
      num_occurrences: z.int().min(0),
      property_name: z.string(),
      // null: 1 (0.15%)
      property_value: z.string().nullable(),
    })
    .optional(),
  value: z.object({
    num_days: z.int().min(0).max(31),
    num_occurrences: z.int().min(0),
    property_name: z.string(),
    // null: 1 (0.12%)
    property_value: z.string().nullable(),
  }),
  varies_by_app_group: z.literal(true),
});
